import React from 'react';
import GuidancePrompt from '../Hub/GuidancePrompt';

/**
 * Widget wrapper for Ask Mabel card
 * Opens chat with Mabel
 */
export default function AskMabelWidget({ onOpenChat }) {
  return (
    <GuidancePrompt onOpenChat={onOpenChat} />
  );
}
